import React from 'react'

const CustomTick = ({ x, y, payload, highlightedYear, onYearClick, tickAngle = 0 }) => {
  const yearValue = payload && payload.value ? payload.value.toString() : null
  const isHighlighted = highlightedYear === yearValue
  const isRotated = tickAngle !== 0
  const textX = isRotated ? 8 : 0
  const textDy = isRotated ? 12 : 14
  return (
    <g
      className='cursor-pointer'
      transform={`translate(${x},${y})`}
      onClick={(e) => {
        e.stopPropagation()
        if (onYearClick) {
          onYearClick(payload.value)
        }
      }}
    >
      <title>Click year to pin value</title>
      <text
        x={textX}
        y={0}
        dy={textDy}
        textAnchor={isRotated ? 'end' : 'middle'}
        fill={isHighlighted ? '#0F172A' : '#334155'}
        fontSize={isHighlighted ? 12.5 : 11.5}
        fontWeight={isHighlighted ? 700 : 500}
        fontFamily="'General Sans', 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
        transform={isRotated ? `rotate(${tickAngle}, ${textX}, 0)` : undefined}
      >
        {payload.value}
      </text>
    </g>
  )
}

export default CustomTick
